<template>
  <div class="overview">
    <el-row>
      <div id="amount">
        <i class="fa fa-money"></i>
        当前帐户余额<span style="color: red; font-weight: bold; font-size: 26px; margin-left: 8px; margin-right: 8px;">{{ amount.amount }}</span>CNY
        <el-button type="text" @click="showRecharge = true" style="margin-left: 8px; color: red; font-size: 12px; font-weight: bold;">在线充值</el-button>
      </div>
    </el-row>
    <el-divider/>
    <div style="display: flex; justify-content: flex-start; align-items: stretch; margin-top: 42px;">
      <div style="flex: 1">
        <el-row style="column-count: 3; column-gap: 0;">
          <el-col style="box-sizing: border-box;" v-for="cueemenu in menusData" :key="cueemenu.ID">
            <ul style="list-style: none; padding-left: 0;">
              <li><h4>{{ cueemenu.name }}</h4></li>
              <li v-for="cl in cueemenu.child" :key="cl.ID">
                <router-link class="navlink" :to="cl.uri" style="color: black; font-size: 12px; text-decoration: none;">{{ cl.name }}</router-link >
              </li>
            </ul>
          </el-col>
        </el-row>
      </div>
      <div style="width: 30vw!important; padding-left: 22px">
        <el-row><h3><i class="fa fa-feed"></i>通知动态</h3></el-row>
        <el-divider></el-divider>
        <div v-for="topics in news.slice(0, 6)" :key="topics.id">
          <a :href="topics.link" target="_blank" type="primary" style="color: black; text-decoration: none;"><h4>{{ topics.title.rendered }}</h4></a>
          <small>
            <el-row style="font-size: 12px;">{{getTime(topics.modified)}}</el-row>
          </small>
          <el-divider></el-divider>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="showRecharge" width="30%">
      <el-form :model="rechargeValue" name="rechargeForm" ref="rechargeForm">
        <el-form-item label="充值金额" prop="money" required>
          <el-input v-model="rechargeValue.money" placeholder="请输入充值金额"></el-input>
        </el-form-item>
        <el-form-item style="text-align: right">
          <el-button type="success" @click="recharge('rechargeForm')"><i class="fa fa-usd"></i>立即充值</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: 'Gateway',
  data () {
    return {
      message: 'initedge用心创造生活!',
      analysis: {},
      news: [],
      menusData: [],
      amount: {},
      showRecharge: false,
      rechargeValue: {}
    }
  },
  mounted () {
    this.GetNews()
    this.menuLoad()
    this.GetBanlance()
  },
  methods: {
    getTime: function (dd) {
      var d = new Date(dd)
      return d.toLocaleDateString() + ' ' + d.toLocaleTimeString()
    },
    menuLoad: function () {
      var that = this
      this.$http.post(that.$apiurl, {method: 'base.getmenu', service: 1}).then(function (ret) {
        var data = ret.body.data
        for (var i = 0; i < data.length; i++) {
          this.menusData.push(data[i])
        }
      })
    },
    GetNews: function () {
      // var api = 'https://notify.alaikis.com/api/post/list'
      var that = this
      // var news = fetch(api, {
      //   method: 'POST',
      //   body: JSON.stringify({
      //     category: '78,79,80'
      //   })
      // }).then(function (ret) {
      //   console.log(ret.json())
      //   return ret.json()
      // })
      // console.log(news)
      // that.news = news ?? []
      that.news = []
    },
    GetBanlance: function () {
      var that = this
      var para = {}
      para.method = 'merchant.merchantamount'
      that.$http.post(that.$apiurl, para).then(function (ret) {
        that.amount = ret.body.data
      })
    },
    hasloaded: function () {
      this.load.close()
      this.load = ''
    },
    fullLoad () {
      this.load = this.$loading({
        lock: true,
        text: '请求处理中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    recharge: function (formname) {
      var that = this
      this.$refs[formname].validate(valid => {
        if (valid) {
          var para = that.rechargeValue
          that.fullLoad()
          para.method = 'merchant.recharge'
          that.$http.post(that.$apiurl, para).then(function (ret) {
            that.hasloaded()
            if (ret.body.data.code === 200) {
              window.open(ret.body.data.url, '_blank')
            } else {
              that.$message.error('支付请求失败，请稍后重试')
            }
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gateway.vue